var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1511 2.24987L4.54956 7.85143L2.50851 5.81037C2.34063 5.64823 2.11578 5.55851 1.88239 5.56053C1.649 5.56256 1.42575 5.65618 1.26071 5.82121C1.09568 5.98625 1.00206 6.2095 1.00003 6.44289C0.998006 6.67628 1.08773 6.90113 1.24987 7.06901L3.92024 9.73938C4.08717 9.90626 4.31353 10 4.54956 10C4.78559 10 5.01196 9.90626 5.17888 9.73938L11.4098 3.50851C11.5719 3.34063 11.6616 3.11578 11.6596 2.88239C11.6576 2.649 11.564 2.42575 11.3989 2.26071C11.2339 2.09568 11.0106 2.00206 10.7772 2.00003C10.5438 1.99801 10.319 2.08773 10.1511 2.24987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f268c89cebe69590adb2ad8b113b0cda.svg";
export { ForwardRef as ReactComponent };